import { getRetailUnitAndLanguage } from './getRetailUnitAndLanguage';

function getApiGwOrigin() {
  if (globalThis.location.host === 'www.ikea.com') {
    return 'https://api.commerce.ikea.com';
  } else if (globalThis.location.host === 'www.cte.ikeadt.com') {
    return 'https://api.commerce.ikeadt.com';
  }
  return '';
}

export const backendUrl = (port?: number) => {
  const portRegex = /:\d{4}/;

  const { retailUnit, language } = getRetailUnitAndLanguage();
  let origin = getApiGwOrigin();

  if (port && portRegex.exec(globalThis.location.origin)) {
    origin = globalThis.location.origin.replace(portRegex, ':' + port);
  }
  return `${origin}/${retailUnit}/${language}`;
};
